import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';

const MANUFACTURE_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: { month: 'short', year: 'numeric' },
    dateA11yLabel: { day: '2-digit', month: '2-digit', year: 'numeric' },
    monthYearA11yLabel: { month: 'long', year: 'numeric' }
  }
};

class ManufactureDateAdapter extends NativeDateAdapter {
  override format(date: Date, _displayFormat: object): string {
    if (!date) {
      return '';
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
}

@Component({
  selector: 'app-manufacture-popup',
  standalone: false,
  templateUrl: './manufacture-popup.html',
  styleUrl: './manufacture-popup.scss',
  providers: [
    { provide: DateAdapter, useClass: ManufactureDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MANUFACTURE_DATE_FORMATS }
  ]
})
export class ManufacturePopup {
  action: string;
  type: string;
  manufactureDate: Date | null = null;
  readonly maxDate = new Date();

  constructor(
    private readonly dialogRef: MatDialogRef<ManufacturePopup>,
    @Inject(MAT_DIALOG_DATA) public data: { action: string; type: string }
  ) {
    this.action = data.action;
    this.type = data.type;
  }

  close() {
    this.dialogRef.close(false);
  }

  confirmManufacture() {
    if (!this.manufactureDate) {
      return;
    }

    const year = this.manufactureDate.getFullYear();
    const month = String(this.manufactureDate.getMonth() + 1).padStart(2, '0');
    const day = String(this.manufactureDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    this.dialogRef.close({ confirmed: true, manufactureDate: formattedDate });
  }
}
